import React, { Component } from "react";
import { connect } from 'react-redux';

import PageHelmet from "../../component/common/Helmet";
import Breadcrumb from "../../elements/common/Breadcrumb";
import Pagination from "../../elements/common/Pagination";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../../component/header/Header";
import Footer from "../../component/footer/Footer";
import NewsList from "../../component/newsList";

import { getAllNews } from '../../redux/actions';

class News extends Component{
    constructor(props) {
        super(props);
        this.state = {
            offset: 0, limit: 6
        }
    }
    
    componentDidMount = () => {
        const {offset, limit} = this.state;
        const { getAllNews } = this.props;
        getAllNews({offset, limit});
    }

    paginationChange = ({data}) => {
        const { limit } = this.state;
        const { getAllNews } = this.props;
        
        this.setState({offset: data.selected});
        getAllNews({limit, offset: data.selected})
    }

    render(){
        const { loading, news, total } = this.props;
        const { limit } = this.state;

        return(
            <React.Fragment>
                <PageHelmet pageTitle='News' />

                 {/* Start Header Area  */}
                <Header headerPosition="header--static logoresize" logo="all-dark" color="color-black"/>
                {/* End Header Area  */}
                
                {/* Start Breadcrump Area */}
                <Breadcrumb title={'News'}   />
                {/* End Breadcrump Area */}


                {/* Start Blog Area */}
                <div className="rn-blog-area ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <NewsList news={news} loading={loading} />
                        </div>
                        <div className="row mt--20">
                            <div className="col-lg-12">
                                {/* Start Pagination Area */}
                                <Pagination total={total} limit={limit} paginationChange={this.paginationChange} />
                                {/* End Pagination Area */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Blog Area */}
                
                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer /> 

            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    const { news, loading, total } = state.News;
    return { news, loading, total };
};

export default connect(mapStateToProps, { getAllNews })(News);
